import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";

import Paths from "./paths";
import {
  FeatureListRequest,
  FeatureListResponse,
  Feature,
  FeatureCreateRequest,
  FeatureUpdateRequest,
  FeatureShortListResponse,
} from "./types";

/**
 * List
 */
export const featureListService = (params: FeatureListRequest) =>
  RestAPIClient.call<FeatureListResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.List,
    config: {
      requireAuthentication: true,
      params,
    },
  });

/**
 * List short
 */
export const featureListShortService = (params: FeatureListRequest) =>
  RestAPIClient.call<FeatureShortListResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.ListShort,
    config: {
      requireAuthentication: true,
      params,
    },
  });

/**
 * Detail
 */
export const featureDetailService = (id: number) =>
  RestAPIClient.call<Feature>({
    method: HTTPRequestMethods.GET,
    url: `${Paths.Detail}/${id}`,
    config: {
      requireAuthentication: true,
    },
  });

/**
 * Create
 */
export const featureCreateService = (data: FeatureCreateRequest) =>
  RestAPIClient.call<Feature>({
    method: HTTPRequestMethods.POST,
    url: `${Paths.Create}`,
    config: {
      requireAuthentication: true,
    },
    data,
  });

/**
 * Update
 */
export const featureUpdateService = (data: FeatureUpdateRequest) =>
  RestAPIClient.call<Feature>({
    method: HTTPRequestMethods.PUT,
    url: `${Paths.Update}/${data.id}`,
    config: {
      requireAuthentication: true,
    },
    data,
  });

/**
 * Update status
 */
export const featureUpdateStatusService = ({
  id,
  isActive,
}: {
  id: number;
  isActive: boolean;
}) =>
  RestAPIClient.call<Feature>({
    method: HTTPRequestMethods.PUT,
    url: `${Paths.Update}/${id}/${isActive ? "active" : "inactive"}`,
    config: {
      requireAuthentication: true,
    },
  });
